import { RootState } from '@redux/types';

export const lightSelector = (state: RootState) => state.lights.lights;
